import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsdotBridgeClearancesApiMeta } from "../apiMeta";
import {
  type BridgeClearancesByRouteInput,
  bridgeClearancesByRouteInputSchema,
} from "./shared/bridgeClearances.input";
import {
  type BridgeClearance,
  bridgeClearanceSchema,
} from "./shared/bridgeClearances.output";

/**
 * Metadata for the fetchBridgeClearancesByRoute endpoint
 */
export const bridgeClearancesByRouteMeta = {
  functionName: "fetchBridgeClearancesByRoute",
  endpoint: "/getClearancesAsJson?Route={Route}",
  inputSchema: bridgeClearancesByRouteInputSchema,
  outputSchema: bridgeClearanceSchema.array(),
  sampleParams: { Route: "005" },
  endpointDescription:
    "Get vertical clearance data for bridges on a specific state route.",
} satisfies EndpointMeta<BridgeClearancesByRouteInput, BridgeClearance[]>;

const { fetch, useHook } = createFetchAndHook<
  BridgeClearancesByRouteInput,
  BridgeClearance[]
>({
  api: wsdotBridgeClearancesApiMeta,
  endpoint: bridgeClearancesByRouteMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/bridgeClearances.endpoints").bridgeClearancesGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving vertical clearance data for bridges on a specific state route
 */
export const fetchBridgeClearancesByRoute: FetchFactory<
  BridgeClearancesByRouteInput,
  BridgeClearance[]
> = fetch;

/**
 * React Query hook for retrieving vertical clearance data for bridges on a specific state route
 */
export const useBridgeClearancesByRoute: HookFactory<
  BridgeClearancesByRouteInput,
  BridgeClearance[]
> = useHook;
